import React, { memo } from 'react';
import { useAppSelector } from 'ducks/hooks';
import { selectCardInfoIds, selectCardInfoName, selectCreateParameter } from 'ducks/modals/selectors';
import { CardInfoChildrenParamsProps } from 'ducks/types/prop-types';
import { Pin } from 'modals/parameter-connections/component/Pin';
import { SteppedLineTo } from 'react-lineto';
import { shallowEqual } from 'react-redux';

import cn from 'modals/parameter-connections/component/Components.module.scss';

const CardInfoChildrenParamsBase = ({
  params,
  isCurrentBatchCardInfo,
  handleCreateConnection,
}: CardInfoChildrenParamsProps) => {
  const ids = useAppSelector(selectCardInfoIds, shallowEqual);
  const name = useAppSelector(selectCardInfoName, shallowEqual);
  const create_parameter = useAppSelector(selectCreateParameter, shallowEqual);

  return (
    <div>
      <div className={cn.parameterConnectionWrapper}>{ids && name}</div>
      {params &&
        // TODO: find out the purpose of if comparison
        params.map((el) => {
          if (el.owner_id !== 0) {
            return (
              <>
                <Pin owner_id={ids[0]} pinParams={el} classId={`${el.parameter_name}01`} left />
                <SteppedLineTo
                  // key={i}
                  to={`${el.parameter_name}01`}
                  from={`${el.parameter_name}00`}
                  borderColor="#AFAFAF"
                  borderWidth={2}
                  orientation="h"
                  zIndex={create_parameter.vision ? 99 : 100}
                  delay={0}
                />
              </>
            );
          }
          return (
            <Pin
              key={el.parameter_name}
              owner_id={ids[0]}
              handleCreateConnection={handleCreateConnection}
              status={false}
            />
          );
        })}
      {ids && isCurrentBatchCardInfo && (
        <Pin owner_id={ids[0]} handleCreateConnection={handleCreateConnection} status={false} />
      )}
    </div>
  );
};

export const CardInfoChildrenParams = memo(CardInfoChildrenParamsBase);
